//"android" | "android_x" | "ios" | "macos" | "tdesktop" | "weba" | "webk" | "unigram" | "unknown"

const mobileDevices = ['android', 'android_x', 'ios'];
const pcDevices = ['tdesktop', 'macos'];
const appleDevices = ['macos', 'ios'];

export { appleDevices, mobileDevices, pcDevices };
